/**
 * JHR search lens - a CAMERA button in the search box: scan the barcode on a pack,
 * or photograph something with no barcode. 2026-09-23.
 *
 * Aaron: "is there anything else we can do to really wow people" - the
 * "climbing wall in the foyer". Plan and the numbers behind it:
 * Dropbox/Shopify/SEARCH_WOW_PLAN.md. 85% of search visits are on phones and
 * most customers re-buy the same tubs, so: point the phone at the empty tub,
 * land on that exact product and size.
 *
 * BARCODE -> PRODUCT needs no lookup table of ours: Shopify's own predictive
 * search matches variant barcodes when asked to (resources[options][fields]=
 * variants.barcode). The product's .js is then read to pick the exact variant,
 * so the shopper lands on the right SIZE. A wrong product is worse than none:
 * only an exact barcode match on a variant counts.
 *
 * DECODING: phones with the built-in BarcodeDetector (Chrome on Android) use it.
 * Everything else (iPhone Safari, desktop) loads jhr-zxing.min.js - ONLY when the
 * camera is tapped, never on page load. Numeric codes must pass their check digit.
 *
 * PHOTO: no barcode -> a photo goes to the HQ function searchLens, which returns the
 * words a shopper would type; they go into the box where the shopper can see and
 * change them ("search what's typed" - Aaron, 16 Sept: no guessing, no filters).
 *
 * VOICE SEARCH WAS BUILT AND REMOVED the same day (Aaron, 23 Sept: "it doesn't seem
 * to work... get rid of the microphone one"): iPhone browsers refuse website speech
 * recognition, and Bluetooth headsets add a switch-over lag no website can avoid.
 * The last version with voice: C:/Users/info/dev/club-off/lens/jhr-search-lens.with-voice.js
 * (notes in Dropbox/Shopify/SEARCH_WOW_PLAN.md) if it is ever wanted again.
 *
 * The camera button is for touch screens with a camera API only - holding a pack
 * up to a laptop webcam is not a thing people do.
 */
(function () {
  'use strict';
  if (window.jhrLens) return;

  var script = document.currentScript;
  var ZXING_SRC = script ? script.getAttribute('data-zxing') : '';
  var touch = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
  var canCamera = touch && !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
  // the server half (HQ function searchLens): photo -> search words
  var LENS_API = script ? (script.getAttribute('data-lens-api') || '') : '';
  var warmed = false;
  // wake the server the moment the camera opens, so a cold start overlaps the aiming
  function warmServer() {
    if (!LENS_API || warmed) return;
    warmed = true;
    try { fetch(LENS_API + '?kind=warm', { method: 'GET', mode: 'cors', credentials: 'omit' }).catch(function () { /* */ }); } catch (e) { /* */ }
  }
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var ICON_SCAN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7V5a2 2 0 0 1 2-2h2M17 3h2a2 2 0 0 1 2 2v2M21 17v2a2 2 0 0 1-2 2h-2M7 21H5a2 2 0 0 1-2-2v-2"/><path d="M7 8v8M10 8v8M13 8v8M16 8v8"/></svg>';
  var ICON_PHOTO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 8h3l2-3h6l2 3h3v11H4z"/><circle cx="12" cy="13" r="3.5"/></svg>';
  var ICON_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  function log(q, found) {
    try { if (window.jhrSearchLog && window.jhrSearchLog.onResults) window.jhrSearchLog.onResults(q, found ? 1 : 0, found ? 1 : 0); } catch (e) { /* never the shopper's problem */ }
  }

  // ------------------------------------------------------------------ barcode -> product
  // EAN-8 / UPC-A / EAN-13 check digit. Codes that fail are misreads, not products.
  function checkDigitOk(code) {
    if (!/^\d{8}$|^\d{12,14}$/.test(code)) return false;
    var digits = code.split('').map(Number);
    var check = digits.pop();
    var sum = 0;
    for (var i = digits.length - 1, w = 3; i >= 0; i--, w = (w === 3 ? 1 : 3)) sum += digits[i] * w;
    return (10 - (sum % 10)) % 10 === check;
  }
  // The same pack can come back as a 12-digit UPC or a 13-digit EAN with a leading
  // 0, and Shopify holds whichever the supplier typed. Try both spellings.
  function spellings(code) {
    var out = [code];
    if (/^0\d{12}$/.test(code)) out.push(code.slice(1));
    if (/^\d{12}$/.test(code)) out.push('0' + code);
    return out;
  }
  function suggest(code) {
    var url = root + 'search/suggest.json?q=' + encodeURIComponent(code) +
      '&resources[type]=product&resources[limit]=4&resources[options][fields]=variants.barcode' +
      '&resources[options][unavailable_products]=last';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { return (j && j.resources && j.resources.results && j.resources.results.products) || []; })
      .catch(function () { return []; });
  }
  function exactVariant(product, codes) {
    var path = String(product.url || '').split('?')[0];
    if (!path) return Promise.resolve(null);
    return fetch(path + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) return null;
        for (var i = 0; i < p.variants.length; i++) {
          var b = String(p.variants[i].barcode || '').trim();
          if (b && codes.indexOf(b) !== -1) return { url: path + '?variant=' + p.variants[i].id, title: p.title, variant: p.variants[i].title, available: p.variants[i].available };
        }
        return null;
      })
      .catch(function () { return null; });
  }
  function lookupBarcode(code) {
    var codes = spellings(String(code).trim());
    var i = 0;
    function next() {
      if (i >= codes.length) return Promise.resolve(null);
      return suggest(codes[i++]).then(function (products) {
        var j = 0;
        function tryProduct() {
          if (j >= products.length) return next();
          return exactVariant(products[j++], codes).then(function (hit) { return hit || tryProduct(); });
        }
        return tryProduct();
      });
    }
    return next();
  }

  // ------------------------------------------------------------------ decoders
  var zxingLoading = null;
  function loadZxing() {
    if (window.ZXing) return Promise.resolve(window.ZXing);
    if (zxingLoading) return zxingLoading;
    zxingLoading = new Promise(function (resolve, reject) {
      if (!ZXING_SRC) { reject(new Error('no decoder')); return; }
      var s = document.createElement('script');
      s.src = ZXING_SRC;
      s.async = true;
      s.onload = function () { window.ZXing ? resolve(window.ZXing) : reject(new Error('decoder missing')); };
      s.onerror = function () { zxingLoading = null; reject(new Error('decoder failed to load')); };
      document.head.appendChild(s);
    });
    return zxingLoading;
  }
  function makeDecoder() {
    var wanted = ['ean_13', 'ean_8', 'upc_a', 'upc_e', 'code_128'];
    if ('BarcodeDetector' in window && window.BarcodeDetector.getSupportedFormats) {
      return window.BarcodeDetector.getSupportedFormats().then(function (have) {
        var formats = wanted.filter(function (f) { return have.indexOf(f) !== -1; });
        if (!formats.length) return zxingDecoder();
        var det = new window.BarcodeDetector({ formats: formats });
        return function (video) {
          return det.detect(video).then(function (found) { return found.length ? String(found[0].rawValue || '') : ''; });
        };
      }).catch(zxingDecoder);
    }
    return zxingDecoder();
  }
  function zxingDecoder() {
    return loadZxing().then(function (Z) {
      var reader = new Z.MultiFormatReader();
      var hints = new Map();
      hints.set(Z.DecodeHintType.POSSIBLE_FORMATS, [Z.BarcodeFormat.EAN_13, Z.BarcodeFormat.EAN_8, Z.BarcodeFormat.UPC_A, Z.BarcodeFormat.UPC_E, Z.BarcodeFormat.CODE_128]);
      hints.set(Z.DecodeHintType.TRY_HARDER, true);
      reader.setHints(hints);
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d', { willReadFrequently: true });
      function decodeCanvas(c) {
        try {
          var bitmap = new Z.BinaryBitmap(new Z.HybridBinarizer(new Z.HTMLCanvasElementLuminanceSource(c)));
          return reader.decodeWithState(bitmap).getText();
        } catch (e) { return ''; }                        // NotFound on most frames - normal
      }
      var decode = function (source) {
        if (source instanceof HTMLCanvasElement) return Promise.resolve(decodeCanvas(source));
        var w = source.videoWidth, h = source.videoHeight;
        if (!w || !h) return Promise.resolve('');
        // the middle band of the picture, where the on-screen frame is, at <= 960px wide
        var cw = Math.min(w, 960), scale = cw / w, bandH = Math.round(h * 0.5);
        canvas.width = cw;
        canvas.height = Math.round(bandH * scale);
        ctx.drawImage(source, 0, Math.round((h - bandH) / 2), w, bandH, 0, 0, canvas.width, canvas.height);
        return Promise.resolve(decodeCanvas(canvas));
      };
      decode.canvas = decodeCanvas;
      return decode;
    });
  }

  // ------------------------------------------------------------------ camera screen
  var cam = null;

  function openCamera(input, container) {
    if (cam) return;
    warmServer();
    if (input) input.blur();                              // keyboard down: the camera needs the screen
    var box = document.createElement('div');
    box.className = 'jhr-lens-cam';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Scan a barcode');
    box.innerHTML =
      '<video class="jhr-lens-cam__video" playsinline muted autoplay></video>' +
      '<div class="jhr-lens-cam__frame" aria-hidden="true"><span class="jhr-lens-cam__line"></span></div>' +
      '<button type="button" class="jhr-lens-cam__close">' + ICON_X + '<span>Close</span></button>' +
      '<div class="jhr-lens-cam__panel"><p class="jhr-lens-cam__msg" role="status" aria-live="polite">Starting the camera&hellip;</p>' +
      '<p class="jhr-lens-cam__tip">Point it at the barcode on the pack, label or box.</p>' +
      (LENS_API ? '<button type="button" class="jhr-lens-cam__photo" hidden>' + ICON_PHOTO + '<span>No barcode? Take a photo</span></button>' : '') +
      '</div>';
    document.body.appendChild(box);
    document.documentElement.classList.add('jhr-lens-cam-open');
    cam = { box: box, video: box.querySelector('video'), msg: box.querySelector('.jhr-lens-cam__msg'), stream: null, timer: null, busy: false, last: '', lastAt: 0, closed: false, input: input, container: container };
    var photoBtn = box.querySelector('.jhr-lens-cam__photo');
    if (photoBtn) photoBtn.addEventListener('click', function () { takePhoto(cam); });
    box.querySelector('.jhr-lens-cam__close').addEventListener('click', closeCamera);
    document.addEventListener('keydown', escClose);
    document.addEventListener('visibilitychange', hiddenClose);

    var state = cam;
    navigator.mediaDevices.getUserMedia({ video: { facingMode: { ideal: 'environment' }, width: { ideal: 1280 }, height: { ideal: 720 } }, audio: false })
      .then(function (stream) {
        if (state.closed) { stream.getTracks().forEach(function (t) { t.stop(); }); return null; }
        state.stream = stream;
        state.video.srcObject = stream;
        return state.video.play().catch(function () { /* autoplay muted - play() can reject harmlessly */ }).then(makeDecoder);
      })
      .then(function (decode) {
        if (!decode || state.closed) return;
        say('Looking for a barcode&hellip;');
        var pb = state.box.querySelector('.jhr-lens-cam__photo');
        if (pb) pb.hidden = false;
        scanLoop(state, decode);
      })
      .catch(function (err) {
        if (state.closed) return;
        state.box.classList.add('jhr-lens-cam--error');   // no sweeping line, no "point it at" tip
        var name = err && err.name;
        if (name === 'NotAllowedError' || name === 'SecurityError') say('The camera is blocked. Allow the camera for this website in your phone&rsquo;s settings, then try again.');
        else if (name === 'NotFoundError' || name === 'OverconstrainedError') say('No camera found on this device.');
        else say('The camera could not start. Close this and type what you are looking for.');
      });
  }
  function say(html) { if (cam) cam.msg.innerHTML = html; }
  function escClose(e) { if (e.key === 'Escape') closeCamera(); }
  function hiddenClose() { if (document.hidden) closeCamera(); }

  function scanLoop(state, decode) {
    if (state.closed) return;
    if (state.busy) { state.timer = setTimeout(function () { scanLoop(state, decode); }, 150); return; }
    decode(state.video).then(function (raw) {
      if (state.closed) return;
      var code = String(raw || '').trim();
      // Only a real product number goes any further: 8 or 12-14 digits with a correct check digit (24 Sept, Aaron:
      // "what if someone scans something malicious?"). Text codes - web links, words, anything a stranger could print -
      // are ignored here, before they are searched, logged or shown. QR codes are never decoded at all.
      if (checkDigitOk(code) && !(code === state.last && Date.now() - state.lastAt < 6000)) {
        found(state, code);
      }
    }).catch(function () { /* one bad frame */ }).then(function () {
      if (!state.closed) state.timer = setTimeout(function () { scanLoop(state, decode); }, 150);
    });
  }

  function found(state, code) {
    state.busy = true;
    state.last = code;
    state.lastAt = Date.now();
    if (navigator.vibrate) { try { navigator.vibrate(60); } catch (e) { /* not on iPhone */ } }
    state.box.classList.add('jhr-lens-cam--found');
    say('Barcode read &#10003; &nbsp;Finding it&hellip;');
    lookupBarcode(code).then(function (hit) {
      if (state.closed) return;
      if (!hit) log('barcode ' + code, false);
      else { try { if (window.jhrSearchLog && window.jhrSearchLog.onClick) window.jhrSearchLog.onClick('barcode ' + code, hit.url.split('/products/')[1].split('?')[0], hit.title, 1, 'dropdown'); } catch (e) { /* */ } }
      if (hit) {
        say('Found &#10003; &nbsp;Opening ' + escapeHtml(hit.title) + '&hellip;');
        var go = hit.url;
        closeCamera();
        window.location.href = go;
        return;
      }
      state.box.classList.remove('jhr-lens-cam--found');
      say('We could not find that barcode in our shop. Try the barcode on another side, or close this and type the name.');
      setTimeout(function () { state.busy = false; }, 1500);
    });
  }

  // No barcode: photograph the thing itself. The words come back into the box where the
  // shopper can see and change them - the normal search does the rest.
  function takePhoto(state) {
    if (!state || state.closed || state.photoBusy || !state.video.videoWidth) return;
    state.photoBusy = true;
    state.busy = true;                                    // pause the barcode scan meanwhile
    var v = state.video, scale = Math.min(1, 1024 / Math.max(v.videoWidth, v.videoHeight));
    var c = document.createElement('canvas');
    c.width = Math.round(v.videoWidth * scale);
    c.height = Math.round(v.videoHeight * scale);
    c.getContext('2d').drawImage(v, 0, 0, c.width, c.height);
    state.box.classList.add('jhr-lens-cam--found');
    say('Photo taken &#10003; &nbsp;Working out what it is&hellip;');
    c.toBlob(function (blob) {
      if (!blob) { photoFailed(state, ''); return; }
      fetch(LENS_API + '?kind=photo', { method: 'POST', headers: { 'Content-Type': 'image/jpeg' }, body: blob })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { j.status = r.status; return j; }); })
        .then(function (j) {
          if (state.closed) return;
          var q = String(j.query || '').trim();
          if (!q) { photoFailed(state, j.status === 429 ? 'busy' : ''); return; }
          var input = state.input, container = state.container;
          closeCamera();
          useWords(input, container, q, 'From your photo: <strong>&ldquo;' + escapeHtml(q) + '&rdquo;</strong> &ndash; change the words if it&rsquo;s not quite right.');
        })
        .catch(function () { photoFailed(state, ''); });
    }, 'image/jpeg', 0.82);
  }
  function photoFailed(state, why) {
    if (state.closed) return;
    state.photoBusy = false;
    state.busy = false;
    state.box.classList.remove('jhr-lens-cam--found');
    say(why === 'busy' ? 'Photo search is busy right now. Close this and type what you are looking for.'
      : 'I couldn&rsquo;t tell what that is. Try again closer, with the label facing the camera, or close this and type it.');
  }
  // Words from a photo go into the box like typing; the results page box
  // (no dropdown) sends its form instead.
  function useWords(input, container, words, note) {
    input.value = words;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    var status = statusLine(container);
    if (note) { status.innerHTML = note; status.hidden = false; } else { status.hidden = true; }
    var form = input.closest('form');
    if (form && !input.closest('main-search')) form.submit();
  }

  function closeCamera() {
    if (!cam) return;
    var state = cam;
    cam = null;
    state.closed = true;
    clearTimeout(state.timer);
    if (state.stream) state.stream.getTracks().forEach(function (t) { t.stop(); });
    state.box.remove();
    document.documentElement.classList.remove('jhr-lens-cam-open');
    document.removeEventListener('keydown', escClose);
    document.removeEventListener('visibilitychange', hiddenClose);
  }

  function escapeHtml(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function statusLine(container) {
    var next = container.nextElementSibling;
    if (next && next.classList.contains('jhr-lens-status')) return next;
    var p = document.createElement('p');
    p.className = 'jhr-lens-status';
    p.setAttribute('role', 'status');
    p.setAttribute('aria-live', 'polite');
    p.hidden = true;
    container.insertAdjacentElement('afterend', p);
    return p;
  }

  // ------------------------------------------------------------------ buttons in every search box
  function attach(container) {
    if (container.querySelector('.jhr-lens')) return;
    var input = container.querySelector('.main-search__input');
    if (!input) return;
    var wrap = document.createElement('div');
    wrap.className = 'jhr-lens';
    if (canCamera) {
      var scan = document.createElement('button');
      scan.type = 'button';
      scan.className = 'jhr-lens__scan';
      scan.setAttribute('aria-label', 'Scan a barcode');
      scan.title = 'Scan a barcode';
      scan.innerHTML = ICON_SCAN;
      scan.addEventListener('click', function (e) { e.preventDefault(); openCamera(input, container); });
      wrap.appendChild(scan);
    }
    if (!wrap.children.length) return;
    container.appendChild(wrap);
    container.classList.add('jhr-lens-on', wrap.children.length === 2 ? 'jhr-lens-on--2' : 'jhr-lens-on--1');
  }

  function init() { document.querySelectorAll('.main-search__input-container').forEach(attach); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // for testing from the console: jhrLens.lookupBarcode('5060215375923').then(console.log)
  window.jhrLens = { lookupBarcode: lookupBarcode, checkDigitOk: checkDigitOk, zxingDecoder: zxingDecoder, openCamera: openCamera, closeCamera: closeCamera,
    takePhoto: function () { takePhoto(cam); }, api: LENS_API };
})();
